import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ServicesPreview from './components/ServicesPreview';
import CtaSection from './components/CtaSection';

export default function Home() {
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'InsuranceAgency',
          '@id': `${import.meta.env.VITE_SITE_URL}/#organization`,
          name: 'Summit Appalachia Insurance',
          url: import.meta.env.VITE_SITE_URL,
          telephone: '+16062691190',
          email: 'John@summitappalachia.com',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '1012 N 12th St',
            addressLocality: 'Middlesboro',
            addressRegion: 'KY',
            postalCode: '40965',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 36.6148,
            longitude: -83.7185,
          },
          areaServed: [
            { '@type': 'State', name: 'Kentucky' },
            { '@type': 'State', name: 'Tennessee' },
            { '@type': 'State', name: 'Virginia' },
            { '@type': 'State', name: 'West Virginia' },
          ],
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '09:00',
              closes: '16:30',
            },
          ],
          sameAs: [],
        },
        {
          '@type': 'WebSite',
          '@id': `${import.meta.env.VITE_SITE_URL}/#website`,
          url: import.meta.env.VITE_SITE_URL,
          name: 'Summit Appalachia Insurance',
          publisher: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
        },
        {
          '@type': 'WebPage',
          '@id': `${import.meta.env.VITE_SITE_URL}/#webpage`,
          url: import.meta.env.VITE_SITE_URL,
          name: 'Middlesboro KY Business Insurance | Summit Appalachia Insurance',
          description: 'Summit Appalachia Insurance in Middlesboro, KY specializes in business insurance for coal mining, trucking, contractors, and high-risk industries across Kentucky, Tennessee, Virginia, and West Virginia.',
          isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL}/#website` },
          about: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
        },
      ],
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    document.title = 'Middlesboro KY Business Insurance | Summit Appalachia Insurance';
    return () => { document.getElementById('schema-home')?.remove(); };
  }, []);

  return (
    <div className="font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <ServicesPreview />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
